export async function rolesIndexUseCase(rolRepository) {
    const result = await rolRepository.index();

    result.forEach(x => {
        x = new rolRepository.model_index(x);

        if (!x.isValid()) {
            console.log(x)
            throw new Error("rol inválido");
        }
    })

    return result;
}